import { clsx } from 'clsx';

type DividerIntensity = 'light' | 'medium' | 'hard';

const INTENSITY_OPACITY: Record<DividerIntensity, number> = {
  light: 0.5,
  medium: 0.7,
  hard: 1,
};

interface DividerDashedProps {
  className?: string;
  intensity?: DividerIntensity;
}

/**
 * Full-width horizontal dashed line separator.
 * Extends beyond container to span full viewport width.
 *
 * @param intensity - Opacity level: 'light' (0.5), 'medium' (0.7), 'hard' (0.9)
 */
export function DividerDashed({ className, intensity = 'light' }: DividerDashedProps) {
  return (
    <div
      className={clsx(
        'w-screen border-t border-dashed',
        'relative left-1/2 -translate-x-1/2',
        className
      )}
      style={{ borderColor: `rgba(228, 228, 231, ${INTENSITY_OPACITY[intensity]})` }}
      aria-hidden="true"
    />
  );
}
